/* eslint-disable @typescript-eslint/no-explicit-any */
// we use any throughout as the throttled function can take any args
var throttle = function throttle(callback, limit) {
  var wait = false;
  return function () {
    if (!wait) {
      callback.apply(void 0, arguments);
      wait = true;
      setTimeout(function () {
        wait = false;
      }, limit);
    }
  };
};

export default throttle;